import Select from 'react-select'
import { Icon } from 'assets/index'
import useStorage from 'hooks/useStorage'
import { logoSmallBlack } from 'assets/Icons'
import { selectStyle } from './factory'
import { ResumeInputCard, TextDiv, ErrorMsg } from './style'

interface ICardProps {
  children: string
  icon?: any
  small?: boolean
  green?: boolean
  secondary?: boolean
  disabled?: boolean
  onClick?: any
  name?: string
  options?: object[]
  type?: any
  handleChange?: any
  value?: any
  text?: any
  specialist?: boolean
  defaultValue?: any
  erro?: any
  analyze?: boolean
  errorMsg?: string
  id?: string
}

export default function ResumeInputCardComponent(props: ICardProps) {
  const {
    name,
    children,
    icon,
    options,
    handleChange,
    disabled,
    text,
    specialist,
    defaultValue,
    errorMsg,
  } = props
  const [user] = useStorage('User')

  return (
    <ResumeInputCard {...props}>
      {!name || !icon ? (
        <img
          className="loading-img-button"
          src={logoSmallBlack}
          alt="card icon"
        />
      ) : (
        <>
          <div style={{ marginBottom: 'auto' }}>
            <Select
              defaultValue={defaultValue}
              onChange={(e) => handleChange(e)}
              options={options}
              placeholder={text}
              styles={selectStyle(disabled)}
              isSearchable
              value=""
              isDisabled={disabled || user?.permission === 'READ'}
              {...props}
            />
          </div>
          <TextDiv>
            {icon && (
              <img
                className={specialist ? 'fotoSpecialista' : 'defaultIcon'}
                src={specialist ? icon : Icon(icon)}
                alt="card icon"
              />
            )}
            <p className="title">{name}</p>
          </TextDiv>
          <span className="legend">{children}</span>
        </>
      )}
      {errorMsg && <ErrorMsg errorMsg={errorMsg}>{errorMsg}</ErrorMsg>}
    </ResumeInputCard>
  )
}
